import {handleMFEMessages} from "./messages";
import {broadcast, CHANNELS} from "../../../utils/broadcast";
import {MFE_BASE_PATH, MFES, navigate} from "./navigation";
import {app} from '../../../app';

export const handleUnauthenticatedAPICall = (event, id = 'rv_life') => {
    if (event?.detail?.payload?.origin === 'api-token-auth-failed') {
        handleMFEMessages({subtype: 'warning', data: 'Your session has expired. Please login again.'}, id);
        app.$root.$emit('send_user', null);
        broadcast(CHANNELS.MAIN, {type: 'logged_out'});
        navigate(MFE_BASE_PATH[MFES.AUTH]);
    }
}